<template>
  <span class="ico-wrap">
    <img :src="ico" alt="pay-ico" class="ico" />
  </span>
</template>

<script>
export default {
  name: 'PayIco',
  props: {
    ico: {
      require: true
    }
  }
};
</script>

<style scoped lang="scss">
.ico-wrap {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 34px;
  background-color: #ebebeb;
  border-radius: 6px;
  margin: 0 3px;

  .ico {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 27px;
  }
}
</style>